/**
 * Буфер нод живёт ВНЕ страницы.
 *
 * `useOutlineEngine` создаётся в `NodePage`, то есть заново на каждом переходе. Пока буфер
 * лежал в его состоянии, он не переживал ровно тот сценарий, ради которого нужен: скопировал
 * на одной странице — вставляю на другой. Внутренний буфер терялся, `Cmd+v` откатывался на
 * системный текст, и копия приезжала без тел и без id — как вставка из блокнота.
 *
 * В памяти, не в `localStorage`: здесь лежат id нод, а пережившая перезагрузку ссылка на
 * удалённую ноду хуже пустого буфера. Свёртка (`collapse.ts`) переживает — там ключи строк,
 * и цена ошибки нулевая.
 */

export type ClipboardEntry = { mode: "copy" | "cut"; nodeIds: string[] } | null;

class ClipboardStore {
	private entry: ClipboardEntry = null;
	private listeners = new Set<() => void>();

	subscribe = (listener: () => void): (() => void) => {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	};

	getSnapshot = (): ClipboardEntry => this.entry;

	/** Стрелкой, а не методом: значение попадает в зависимости хуков и обязано быть стабильным. */
	set = (entry: ClipboardEntry): void => {
		this.entry = entry;
		for (const listener of this.listeners) {
			listener();
		}
	};
}

export const clipboardStore = new ClipboardStore();
